export default "__VITE_ASSET__DvfUYd4k__"